import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface StoreSearchCircleSliceI {
    storeSearchCenterCoords: google.maps.LatLngLiteral | undefined,
    searchCircleRadiusInMiles: number | undefined
}

const storeSearchCircleSliceInitialState: StoreSearchCircleSliceI = {
    storeSearchCenterCoords: undefined,
    searchCircleRadiusInMiles: undefined
}

const storeSearchCircleSlice = createSlice({
    name: 'storeSearchCircleSlice',
    initialState: storeSearchCircleSliceInitialState,
    reducers: {
        setStoreSearchCenterCoords(state, action: PayloadAction<google.maps.LatLngLiteral | undefined>) {
            state.storeSearchCenterCoords = action.payload;
        },
        setSearchCircleRadiusInMiles(state, action: PayloadAction<number | undefined>) {
            state.searchCircleRadiusInMiles = action.payload;
        }
    }
});

export const storeSearchCircleSliceActions = storeSearchCircleSlice.actions;
export default storeSearchCircleSlice;